module.exports = __webpack_public_path__ + "img/print-bg.7c84679a.png";